import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  useTheme
} from "@mui/material";
import _ from "lodash";
import moment from "moment";
import React, { memo, useEffect, useRef, useState } from "react";
import { useStyle } from "../style";

const BillingTable = ({data, setData, setPostData , forwardRef}) => {
  const theme = useTheme();
  const classes = useStyle();
  const[active, setActive] = useState(null)
  const qtyRef = useRef(null)

  function getSelectedRow(e){
setActive(e)
const arr=[...data]

   } 
function handleQtyChange(e){
  const arr=[...data]
  setData([])
  const inputValue = e.target.value.replace(/[^0-9]/g, '');
  // Ensure the value is below the specified maximum
  const numericValue = inputValue ? parseInt(inputValue, 10) : 0;
  const sanitizedValue = Math.min(numericValue, parseFloat(arr[active].qty));
  
  // arr[active].retQty = sanitizedValue
  // arr[active].totalAmt = sanitizedValue * arr[active].rate
  // setData(arr)
  if(sanitizedValue===0){
    arr[active].retQty = sanitizedValue
    arr[active].gst_amt = parseFloat(( arr[active].mrp - arr[active].mrp * arr[active].dis_per / 100) * (arr[active].gst_per / 100 * arr[active].qty)).toFixed(0)
    arr[active].cess_amt = parseFloat(( arr[active].mrp - arr[active].mrp * arr[active].dis_per / 100) * (arr[active].cess_per / 100 * arr[active].qty)).toFixed(0)
    arr[active].totalAmt = parseFloat(arr[active].qty * ( arr[active].rate - arr[active].rate * arr[active].dis_per / 100)).toFixed(0)
    setData(arr)
    
    }
    else{
      arr[active].retQty = sanitizedValue
      arr[active].gst_amt = parseFloat(( arr[active].mrp - arr[active].mrp * arr[active].dis_per / 100) * (arr[active].gst_per / 100 * sanitizedValue)).toFixed(0)
      arr[active].cess_amt = parseFloat(( arr[active].mrp - arr[active].mrp * arr[active].dis_per / 100) * (arr[active].cess_per / 100 * sanitizedValue)).toFixed(0)
      arr[active].totalAmt = sanitizedValue * ( arr[active].rate - arr[active].rate * arr[active].dis_per / 100)
      setData(arr)
     }
}
useEffect(() => {
if(data.length > 0){
  let arr = []
  data.filter(value=>value.retQty > 0).map(val => {
    const obj = {
      docdate: moment().format('YYYY/MM/DD'), 
      prodid:val.prodid,
      dis_per:val.dis_per,
      dis_amt: val.dis_amt,
      mrp: val.mrp,
      rate: val.rate,
      qty: val.retQty,
      gst_per: val.gst_per,
      gst_amt: val.gst_amt,
      cess_per: val.cess_per,
      cess_amt: val.cess_amt,
      barcode: val.barcode,
      head_id:val.head_id,
      type_id:val.type_id,
      subcat_id:val.subcat_id,
      cat_id:val.cat_id,
      uom_id:val.uom_id,
      company_id: val.company_id,
      igst_per: 0
    }
    arr.push(obj)
  }) 
  setPostData((prevState) => ({...prevState , sales_return_details : arr}))
}
},[data])
console.log(data)
return (
    <Grid className="w-full h-full">
      <TableContainer className={classes.tblRoot}>
        <Table stickyHeader  className={classes.table}>
          <TableHead className={classes.tblHeader}>
            <TableRow className={classes.tablrow}>
              <TableCell className={classes.tblCell} sx={{borderLeft:'0.5px solid  #ccc'}}>Sno</TableCell>
              <TableCell className={classes.tblCell}>Product Code</TableCell>
              <TableCell className={classes.tblCell}>Description</TableCell>
              <TableCell className={classes.tblCell}>MRP</TableCell>
              <TableCell className={classes.tblCell}>GST%</TableCell>
              <TableCell className={classes.tblCell}>Rate</TableCell>
              <TableCell className={classes.tblCell}>Dis%</TableCell>
              <TableCell className={classes.tblCell}>Qty</TableCell>
              <TableCell className={classes.tblCell}>Return Qty</TableCell>
              <TableCell className={classes.tblCell}>GST</TableCell>
              {/* <TableCell className={classes.tblCell}>CESS</TableCell> */}
              <TableCell className={classes.tblCell}>Amount</TableCell>
              {/* <TableCell className={classes.tblCell}>Reason</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 ? _.map(data, (val, idx) => (
               <TableRow className={classes.tablrow} key={idx} onClick={() => getSelectedRow(idx)}>
               <TableCell  padding="checkbox" className={classes.tblContentCell}>{idx + 1}</TableCell>
                     <TableCell>{val.pro_code}</TableCell>
               <TableCell variant="body" className={classes.tblContentCell}>{val.pro_name}</TableCell>
               <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>{Math.round(val.mrp)}</TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{Math.round(val.gst_per)}</TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{Math.round(val.rate)}</TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{Math.round(val.dis_per)}%</TableCell>
              
               <TableCell>{val.qty}</TableCell>
               <TableCell className={classes.tblContentCell} sx={{width:100}}>
                <TextField 
                size="small"
                inputRef={qtyRef}
                value={val.retQty}
                onChange={handleQtyChange}
                />
               </TableCell>
               <TableCell className={classes.tblContentCell} sx={{width:100}}>{Math.round(val.gst_amt)}</TableCell>
               {/* <TableCell className={classes.tblContentCell} sx={{width:100}}>{val.cess_amt}</TableCell> */}
               <TableCell className={classes.tblContentCell} sx={{width:100}}>{parseFloat(val.totalAmt).toFixed(0)}</TableCell>
            {/* <TableCell className={classes.tblContentCell} sx={{width:100}}></TableCell> */}
               {/* <TableCell className={classes.tblContentCell} sx={{width:100}}><IconButton><Delete sx={{color:'red', fontSize:18}}/></IconButton></TableCell> */}
             </TableRow>
            )) :
            <TableRow className={classes.tablrow}>
            <TableCell  padding="checkbox" className={classes.tblContentCell} sx={{borderLeft:'0.5px solid  #ccc'}}>{data.length + 1}</TableCell>
            <TableCell  padding="checkbox" sx={{ width: 120 }} className={classes.tblContentCell}></TableCell>
            <TableCell variant="body" className={classes.tblContentCell}></TableCell>
            <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}></TableCell>
            <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}></TableCell>
            <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}></TableCell>
            <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}></TableCell>
            <TableCell  padding="checkbox" sx={{ width: 120 }}  className={classes.tblContentCell}></TableCell>
            <TableCell  padding="checkbox" sx={{ width: 120 }}  className={classes.tblContentCell}></TableCell>
            <TableCell className={classes.tblContentCell} sx={{width:100}}></TableCell>
            {/* <TableCell className={classes.tblContentCell} sx={{width:100}}></TableCell> */}
            <TableCell className={classes.tblContentCell} sx={{width:100}}></TableCell>
            {/* <TableCell className={classes.tblContentCell} sx={{width:100}}></TableCell> */}
          </TableRow>
          }  
          </TableBody>
        </Table>
      </TableContainer>
     
    </Grid>
  );
};

export default memo(BillingTable);



